
<dashboardnav>
  <cradua-paymentstatus
  [paymentstatuss]="paymentstatuss$ | async"
  (paymentstatus)="onSubmitPaymentStatus($event)"
  (deletePaymentStatusEvent)="onDeletePaymentStatus($event)"
  *ngIf="(isLoadingPaymentStatus$ | async ) === false"
  >
</cradua-paymentstatus>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingPaymentStatus$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
